var _rect, _path, _path2, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIhxSuportUpdate = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    rx: 7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5113_1477)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5113_1477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3.5H2.5V24.5H23.5V3.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5113_1477)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5113_1477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50427 3.50421H23.4958V24.4958H2.50427V3.50421Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5113_1477)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.81323 22.3704C4.81323 18.6769 8.4878 15.6793 12.9999 15.6793C17.5121 15.6793 21.1866 18.6769 21.1866 22.3704C21.1866 22.6202 20.9885 22.8164 20.7364 22.8164H5.2635C5.01139 22.8164 4.81323 22.6202 4.81323 22.3704Z",
    fill: "#0077F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 13.9999C15.4153 13.9999 17.3732 12.0421 17.3732 9.62677C17.3732 7.21148 15.4153 5.2536 13 5.2536C10.5847 5.2536 8.62683 7.21148 8.62683 9.62677C8.62683 12.0421 10.5847 13.9999 13 13.9999Z",
    fill: "#0077F7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5113_1477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(2.5 3.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIhxSuportUpdate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IhxSuportUpdate.334cf23f.svg";
export { ForwardRef as ReactComponent };